import { ButtonBase, Modal as MtModal } from '@patrianna/core-components'
import clsx from 'classnames'
import * as React from 'react'

export type ModalDialogProps = {
  onAccept: () => void
  onDismiss: () => void
  onClear: () => void
  onSetToday: () => void
  okLabel?: React.ReactNode
  cancelLabel?: React.ReactNode
  clearLabel?: React.ReactNode
  todayLabel?: React.ReactNode
  clearable?: boolean
  showTodayButton?: boolean
  showTabs?: boolean
  wider?: boolean
  open: boolean
  children?: React.ReactNode
}

export const ModalDialog = ({
  open,
  children,
  onAccept,
  onDismiss,
  okLabel,
  cancelLabel,
  clearable,
  showTodayButton,
  ...other
}: ModalDialogProps) => (
  <MtModal open={open} onClose={onDismiss} {...other}>
    <div className='MuiDialog-custom'>
      <div
        className={clsx(
          'MuiPaper-root MuiDialog-paper MuiPickersModal-dialogRoot MuiDialog-paperScrollPaper MuiDialog-paperWidthSm MuiPaper-elevation24 MuiPaper-rounded',
          'MuiDialogContent-root',
          'MuiPickersModal-dialog',
        )}
      >
        {children}
        <div
          className={clsx('MuiDialogActions-root MuiDialogActions-spacing', {
            'MuiPickersModal-withAdditionalAction': clearable || showTodayButton,
          })}
        >
          {cancelLabel && (
            <ButtonBase variant='outlined' onClick={onDismiss}>
              {cancelLabel}
            </ButtonBase>
          )}

          {okLabel && (
            <ButtonBase variant='outlined' onClick={onAccept}>
              {okLabel}
            </ButtonBase>
          )}
        </div>
      </div>
    </div>
  </MtModal>
)

ModalDialog.displayName = 'ModalDialog'

export default ModalDialog
